<template>
<div class="chapter">
<div class="inner_page">
<div class="frontMatter">
<div class="p"><a id="title24"></a><span><em class="i">Paradoxically, academic writers are often inhibited when it comes to speaking directly, possibly because they were all little goody-goodies in junior high school, and they’re being massed together in university departments, and when you put all the smartest in the class together, there’s a tremendous anxiety about whether one can live up to the seriousness of the enterprise.</em></span></div>
<div class="p-blanc"><span> <br/></span></div>
<div class="p-d"><span>– Terry Castle</span></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781429949934_fm01.vue?25f3eea8